<template>
<div class='tableScope tra-fast posR'>
  <div class='table table-5x cb'>
     <div class="scrollHide tra-fast fL"
         :style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length*.7+stage.setting.system.autoColumnWidth[1]}"
         scrollFloatX="false"
         >
      <div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
        <div class="sequence" :class='{cMain: this.name}' @click='sortList("name")'>{{getLanguageStr("word1719","子系统名称")}} <span :sequence="name"></span></div>
       
      </div>
      <div class="fixedScrollBar scrollY tra-fast h15x"
           scroll="{'group':'consumption'}">
        <table>
          <thead class="head-token">
            <tr>
              <th></th>
            </tr>
          </thead>
          <tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
            <tr class="curP pl2x-imp"
                v-for="(item, index) in data"
                :key="index">
              <td :title="item.name">{{item.name}}</td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  <div scroll="{'axis':'x'}" >
        <div class="tableSys head noSelect b cField bdLight-bottom " :style="{
              'min-width':
              stage.setting.system.autoColumnWidth[0] * column.length + stage.setting.system.autoColumnWidth[1],
          }" scrollFloatY="false">
          
          <div class="taL sequence" :title="getLanguageStr('plant_detail133', '通讯状态')">
            {{ getLanguageStr("plant_detail133", "通讯状态") }}
          </div>
          <div class="taL sequence" :title="getLanguageStr('plant_detail183', '报警状态')">
            <span>{{ getLanguageStr("plant_detail183", "报警状态")}}</span>
          </div>
          <div class="taL sequence" :title="getLanguageStr('word977', '用电功率')+'(W)'" :class='{cMain: this.usePower}' @click='sortList("usePower")'>
            <span>{{ getLanguageStr("word977", "用电功率")+'(kW)'}}</span>
             <span :sequence="usePower"></span>
          </div>
          <div class="taL sequence" :title="getLanguageStr('word527', '当日用电量')+'(kWh)'" :class='{cMain: this.useValue}' @click='sortList("useValue")'>
            <span>{{ getLanguageStr("word527", "当日用电量")+'(kWh)'}}</span>
            <span :sequence="useValue"></span>
          </div>
          <div class="taL sequence" :title="getLanguageStr('plant_list37', '累计用电量')+'(kWh)'" :class='{cMain: this.useUploadTotalOffset}' @click='sortList("useUploadTotalOffset")'>
            <span>{{ getLanguageStr("plant_list37", "累计用电量")+'(kWh)'}}</span>
            <span :sequence="useUploadTotalOffset"></span>
          </div>
        </div>
        <div class="fixedScrollBar scrollY tra-fast h15x" scroll="{'group':'consumption'}">
          <table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
            <thead class="head-token">
              <tr>
                
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>       
              </tr>
            </thead>
            <tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
              <tr v-for="(item, index) in data" :key="index">
                <td :title="item.networkStatus?getTypeText(item.networkStatus, 'connectStatusForchild').name:'--'"><div class='dian' :style="{'background-color':getTypeText(item.networkStatus, 'connectStatusForchild').color}"></div>{{item.networkStatus?getTypeText(item.networkStatus, 'connectStatusForchild').name:'--' }}</td>
                <td :title="item.warningStatus?getTypeText(item.warningStatus,'alarmStateChild').name:'--'"><div class='dian' :style="{'background-color':getTypeText(item.warningStatus, 'alarmStateChild').color}"></div>{{item.warningStatus?getTypeText(item.warningStatus, 'alarmStateChild').name:'--' }}</td>
                <td :title="item.usePower" >{{item.usePower!==null?floatFix(item.usePower/1000,2,null,null,true):'--' }}</td>
                <td :title="item.useValue">{{floatFix(item.useValue,2,null,null,true) }}</td>
                <td :title="item.useUploadTotalOffset">{{item.useUploadTotalOffset!==null?floatFix(item.useUploadTotalOffset,2,null,null,true): '--' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      </div>
       <div class="tableBatch bgContent cSub tra-fast myListHeight01"
           :class="{disable:!data.length}">
        <Pagination class="ml2x"
                    :pagination="pagination"
                    :getList="getList"
                    ref="Pagination"></Pagination>
      </div>
      </div>
</template>
<script>
import { getLanguageStr } from '@/util/language'
import {mixin} from './commonMethds'
import * as lib from '@/util/lib.js'
import Pagination from '@/components/common/ui/Pagination.vue'
export default {
  name: 'consumption',
  mixins: [mixin],
  components: {Pagination},
  data () {
    return {
      stage,
      floatColumn: new Array(1),
      column: new Array(6),
      data: [],
      name: 'ASC',
      usePower: '',
      useValue: '',
      useUploadTotalOffset: '',
      pagination: {} // 分页数据
    }
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    floatFix: lib.floatFix,
    setaparam () {
      this.requestParams = {
        'order.direction': 'ASC',
        'order.property': 'name'
      }
    },
    sortList (name) {
      switch (name) {
        case 'name':
          this.name === 'ASC' ? this.name = 'DESC' : this.name = 'ASC'
          this.useValue = ''
          this.useUploadTotalOffset = ''
          this.usePower = ''
          this.requestParams = {
            'order.direction': this.name,
            'order.property': 'name'
          }
          break
        case 'usePower':
          this.name = ''
          this.useValue = ''
          this.useUploadTotalOffset = ''
          this.usePower === 'ASC' ? this.usePower = 'DESC' : this.usePower = 'ASC'
          this.requestParams = {
            'order.direction': this.usePower,
            'order.property': 'use_power'
          }
          break
        case 'useValue':
          this.name = ''
          this.useValue === 'ASC' ? this.useValue = 'DESC' : this.useValue = 'ASC'
          this.useUploadTotalOffset = ''
          this.usePower = ''
          this.requestParams = {
            'order.direction': this.useValue,
            'order.property': 'use_value'
          }
          break
        case 'useUploadTotalOffset':
          this.name = ''
          this.useValue = ''
          this.usePower = ''
          this.useUploadTotalOffset === 'ASC' ? this.useUploadTotalOffset = 'DESC' : this.useUploadTotalOffset = 'ASC'
          this.requestParams = {
            'order.direction': this.useUploadTotalOffset,
            'order.property': 'use_upload_total_offset'
          }
          break
      } 
      this.getList()
    }
  },
  mounted () {
    // this.getList()
    lib.setScroll($(this.$el).find('[scroll]'))
    
  }
}
</script>
<style lang="scss" scoped>
.dian{
  width: .5em;
  height: .5em;
  border-radius: 50%;
  display: inline-block;
  margin-right: 1em;
  margin-top: .4em;
}
</style>


// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/Consumption.vue